import { ErrorPage, LoadingSpinner } from 'flos-react-cvi';
import React from 'react';
import { connect } from 'react-redux';
import { CoverageSettings } from './containers/coverage-settings';
import { CurrentInsurances } from './containers/current-insurances';
import { CustomerInfo } from './containers/customer-info';
import { PaymentInfo } from './containers/payment-info';
import { PriceBar } from './containers/price-bar';
import { selectCurrentStep, selectResources, selectUiStatus } from './store/selectors';
import { initApp, log } from './store/thunks';
import { ReceiptPage } from './containers/receipt-page';
import './App.css';

class App extends React.Component {
    state = {
        hasError: false,
        isReceiptPage: false
    };

    componentDidMount() {
        const isReceiptPage = this.props.config.display === 'receipt';
        this.props.initApp(isReceiptPage);

        if (isReceiptPage) {
            this.setState({ isReceiptPage });
        }
    }

    componentDidCatch(error) {
        this.setState(
            {
                hasError: true
            },
            () => this.props.logError(error)
        );
    }

    render() {
        const { uiStatus, resources, currentStep } = this.props;

        if (uiStatus === 'initializing') {
            return <LoadingSpinner />;
        }

        if (uiStatus === 'error' || this.state.hasError) {
            return <ErrorPage resources={resources} />;
        }

        if (this.state.isReceiptPage) {
            return <ReceiptPage />;
        }

        return (
            <div data-testid="alfred-content-accident-insurance-app" className="notranslate">
                <PriceBar />
                <CoverageSettings />
                {currentStep >= 2 && <CurrentInsurances />}
                {currentStep >= 3 && <CustomerInfo />}
                {currentStep >= 4 && <PaymentInfo />}
            </div>
        );
    }
}

const mapStates = state => ({
    uiStatus: selectUiStatus(state),
    resources: selectResources(state),
    currentStep: selectCurrentStep(state)
});

const mapDispatch = (dispatch, ownProps) => ({
    initApp: isReceiptPage => dispatch(initApp(ownProps.config, isReceiptPage)),
    logError: error => dispatch(log('error', error))
});

export default connect(mapStates, mapDispatch)(App);
